import {Brand} from '../models/brand.model';
import {ProductRepository} from '../repository/ProductRepository';

export class GetAllBrandsUseCase {
  constructor (private repo: ProductRepository) {}

  async execute (): Promise<Brand[]> {
    return this.repo.getBrands();
  }
}
